import { css } from "@emotion/css";
export const createLensFolderModalStyles = css`
    .ant-modal-body > div {
        min-height: initial;

        > div {
            margin-top: 0;
            padding-right: 0;
            padding-left: 0;
        }
    }
`;
